import 'isomorphic-fetch'
import Cookies from 'js-cookie';
import {TOKEN_BASIC} from '../constants/config'

export function getTokenFromCookie(){
  let token;
  try {
    let account = Cookies.getJSON("account");
    if (typeof account === 'string') {
      try { account = JSON.parse(account); } catch(e) {}
    }
    if (!account) {
      let raw = Cookies.get("account");
      if (raw) {
        try { account = JSON.parse(decodeURIComponent(raw)); } catch(e) {
          try { account = JSON.parse(decodeURI(raw)); } catch(e2) {
            try { account = JSON.parse(raw); } catch(e3) {}
          }
        }
      }
    }
    if (!account) {
      let rawSIP = Cookies.get("accountSIP");
      if (rawSIP) {
        try { account = JSON.parse(decodeURIComponent(rawSIP)); } catch(e) {
          try { account = JSON.parse(decodeURI(rawSIP)); } catch(e2) {
            try { account = JSON.parse(rawSIP); } catch(e3) {}
          }
        }
      }
    }
    if (account && typeof account === 'object') {
      token = account.token || account.access_token;
    }
  } catch(e) {
    console.error("Error obteniendo token de cookies:", e);
  }
  return token;
}

function callGETWithToken(endpoint, token) {
  return fetch(endpoint, {
    method: "GET", headers: { 
      "Content-Type": "application/json", 
      "Authorization": "Bearer " + token
    }})
  .then(response =>
    response.json().then(json => ({ json, response }))
  ).then(({ json, response }) => {
    if (!response.ok) {
      return Promise.reject(json)
    }
    return json;
  })
  .then(response => response);
}

function callGET(endpoint) {
  let token = getTokenFromCookie();
  return callGETWithToken(endpoint, token);
}

/*function callPOST(endpoint, request) {
  console.log("callPOST", endpoint, request)
  return fetch(endpoint, {
                          method: "POST", headers: { 
                            "Content-Type": "application/json", 
                            "Authorization": "Bearer " + getTokenFromCookie()
                          }, 
                          body: JSON.stringify(request.payload)
                        }
              )
  .then(response =>
    response.json().then(json => ({ json, response })))
  .then(({ json, response }) => {
    if (!response.ok) {
      return Promise.reject(json)
    }
    const camelizedJson = camelizeKeys(json)
    return Object.assign({},normalize(camelizedJson, schema),{})
  })
  .then(
    response => ({response})
  )
}*/

const tokenBasic = TOKEN_BASIC;

function callLoginPOST(endpoint, request) {
  //console.log("callPOST", request)
  return fetch(endpoint, {
                          method: "POST", 
                          headers: {  "Content-Type": "application/json"/*, 
                                      /*"Authorization": 'Basic ' + tokenBasic*/}, 
                          body: JSON.stringify(request.payload)
                        }
              )
  .then(response =>
    response.json().then(json => ({ json, response }))
  ).then(({ json, response }) => {
    //console.log(response)
    if (!response.ok) {
      return Promise.reject(json)
    }
    //console.log("json: ",json)
    return json;
    //const camelizedJson = camelizeKeys(json)
    //return Object.assign({},normalize(camelizedJson, schema),{})
  })
  .then(
    response => ({response})
  )
}

function callPOST(endpoint, request) {
  //console.log("callPOST", endpoint, request)
  
  let token = getTokenFromCookie();
  return fetch(endpoint, {
                          method: "POST", headers: {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + token
                          },
                          body: request
                        }
              )
  .then(response =>
    response.json().then(json => ({ json, response })))
  .then(({ json, response }) => {
    if (!response.ok) {
      return Promise.reject(json)
    }
    return json
  })
  .then(
    response => ({response})
  )
}
function callPOSTWithToken(endpoint, request, token) {
  return fetch(endpoint, {
                          method: "POST", headers: {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + token
                          },
                          body: request,
                        }
              )
  .then(response =>
    response.json().then(json => ({ json, response })))
  .then(({ json, response }) => {
    if (!response.ok) {
      return Promise.reject(json)
    }
    return json
  })
  .then(
    response => ({response})
  )
}
function callLoginGET(endpoint) {
  console.log("callLoginGET")
  return fetch(endpoint, {
                          method: "GET", 
                          headers: {  "Content-Type": "application/x-www-form-urlencoded", 
                                      "Authorization": 'Basic ' + tokenBasic}
                        }
              )
  .then(response =>
    response.json().then(json => ({ json, response })))
  .then(({ json, response }) => {
    if (!response.ok) {
      return Promise.reject(json)
    }
    return json
  })
  .then(
    response => ({response})
  )
}

export const getCall = endpoint => callGET(endpoint)
export const getCallWithToken = (endpoint, token) => callGETWithToken(endpoint, token)
export const postCall = (endpoint, payload) => callPOST(endpoint, payload)
export const postCallWithToken = (endpoint, payload, token) => callPOSTWithToken(endpoint, payload, token)
export const loginPOST = (endpoint, payload) => callLoginPOST(endpoint, payload)
export const loginGET = (endpoint) => callLoginGET(endpoint)

